import React, {Component} from 'react'
import { Scrollbars } from 'react-custom-scrollbars'

import Message from "../Message/Message";
import _ from 'lodash'

// Import Scss
import './MessageList.scss'

class MessageList extends Component {

  componentDidMount() {
    this.refs.messageList.scrollToBottom()
  }

  componentWillUpdate() {
    const scrollValues = this.refs.messageList.getValues()
    const scrolledPixels = Math.abs(scrollValues.scrollHeight - scrollValues.scrollTop - scrollValues.clientHeight)
    this.scrolledToBottom = scrolledPixels <= 5
    this.oldScrollHeight = scrollValues.scrollHeight
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.messages !== this.props.messages
  }

  componentDidUpdate(prevProps, prevState) {
    const {messageList} = this.refs
    if (this.oldScrollHeight && messageList.getScrollHeight() > this.oldScrollHeight) {
      messageList.scrollTop(messageList.getScrollHeight() - this.oldScrollHeight)
    }

    const lastPrevMessage = _.last(prevProps.messages)
    const lastCurrentMessage = _.last(this.props.messages)

    if (lastPrevMessage && lastCurrentMessage) {
      const needScrollToBtm = lastPrevMessage.id !== lastCurrentMessage.id && lastCurrentMessage.findme_chatroom_member_id === this.props.currentChatroomMemberId
      if (this.scrolledToBottom || needScrollToBtm) {
        messageList.scrollToBottom()
      }
    } else {
      messageList.scrollToBottom()
    }
  }

  onScroll = (e) => {
    if (e.target.scrollTop > 0 || e.target.scrollHeight === e.target.clientHeight) return
    const topMessage = this.props.messages[0]
    this.props.loadMoreMessages(topMessage.findme_chatroom_id, topMessage.id)
  }

  render() {
    let currentChatroomMemberId = this.props.currentChatroomMemberId

    const renderMessages = this.props.messages.map((message,key) => (
      <Message
        className={message.findme_chatroom_member_id === currentChatroomMemberId ? "right" : ""}
        id={message.id}
        key={key}
        mode={this.props.mode}
        message={message}
        chatroomMemberId={message.findme_chatroom_member_id}
        isMyself={message.findme_chatroom_member_id === currentChatroomMemberId }
      />
    ))

    return(
      <div className="message-list">
        <Scrollbars
          renderTrackHorizontal={props => <div {...props} className="track-horizontal" />}
          renderTrackVertical={props => <div {...props} className="track-vertical" />}
          onScroll={this.onScroll}
          autoHide
          ref="messageList"
        >
          <ul
            className="floating-support-chat__body"
          >
            {renderMessages}
          </ul>
        </Scrollbars>
      </div>
    )
  }
}

export default MessageList



// WEBPACK FOOTER //
// ./src/components/MessageList/MessageList.js